<template>
    <div class="ma-5">
        <v-container>
            <v-row class="mb-4 name-line">
                <v-img :src="info.picture" class="rounded-xl mb-2"></v-img>
                <h1>{{ info.nameLabel }}
                    <v-icon v-for="(color, index) in info.band_color" :key="index" class="band-icon"
                        :class="{ 'band-white': isWhite(color) }" :style="{ color: color + ' !important' }">
                        mdi-circle
                    </v-icon>
                </h1>
                <!-- <h4>{{ info.comment }}</h4> -->
                <p class="comment">
                    <!-- <span v-if="info.genderLabel">{{ info.genderLabel }}</span>
                    {{ $t('detail.birthday', { date: info.birthdayLabel }) }}
                    <span v-if="info.pairLabel">
                        {{ $t('detail.pair', { name: info.pairLabel }) }}
                    </span>
                    {{ $t('detail.place', { place: info.placeLabel }) }} -->
                    <span v-if="info.genderLabel">
                        {{ info.genderLabel }}
                    </span>
                    <span v-if="info.birthdayLabel">
                        {{ $t('detail.birthday', { date: info.birthdayLabel }) }}
                    </span>
                    <span v-if="info.pairLabel">
                        {{ $t('detail.pair', { name: info.pairLabel }) }}
                    </span>
                    <span v-if="info.placeLabel">
                        {{ $t('detail.place', { place: info.placeLabel }) }}
                    </span>
                    <span v-if="info.comment">
                        {{ info.comment }}
                    </span>
                </p>
            </v-row>


            <!-- <v-row justify="center" class="ma-4">
                <v-dialog width="500">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" v-bind="attrs" v-on="on" rounded width="250" large>
                            この子だった！！！
                        </v-btn>
                    </template>

<v-card>
    <v-card-title class="blue lighten-2 white--text">
        どちらかえらんでね
    </v-card-title>
    <v-divider></v-divider>
    <v-card-actions>
        <v-btn color="primary" text @click="sendDB('draw-penguin')">
            ほかのペンギンをかく
        </v-btn>
    </v-card-actions>
    <v-card-actions>
        <v-btn color="primary" text @click="sendDB('')">
            さいしょにもどる
        </v-btn>
    </v-card-actions>
</v-card>
</v-dialog>
</v-row> -->
            <v-row justify="center" class="ma-4">
                <v-btn color="primary" rounded width="250" large @click="sendDB('')">
                    {{ $t('detail.wasThisOne') }}
                </v-btn>
            </v-row>

            <v-row justify="center" class="ma-4">
                <v-btn @click="goBack()" color="gray" rounded width="250" large>{{ $t('detail.notThisOne') }}</v-btn>
            </v-row>
        </v-container>
    </div>
</template>


<script>
import { fire, getPrevScreen, setCurrentScreen } from '@/utils/logger';

export default {
    // props: ['aquarium'], // ルーターから受け取るプロップス
    data() {
        return {
            viewId: null,
            viewStart: 0,
            activeStart: 0,
            activeTotal: 0,
            viewLeft: false,
        };
    },
    props: {
        aquarium: String,
        info: Object,
        rank: Number,
        all_info: Array
    },
    computed: {
        searchId() {
            // Draw側で sessionStorage.setItem('last_search_id', ...) 済みの想定
            return this.$store.state.search_id
                || sessionStorage.getItem('last_search_id')
                || null;
        },
        penguinName() {
            // 表示名（ローカライズ後）優先でOK
            return this.info?.nameLabel || this.info?.name || '';
        }
    },
    mounted() {
        this.$returnScroll();

        // page_view(detail)
        this.viewId = crypto.randomUUID();
        this.viewStart = performance.now();
        this.activeStart = this.viewStart;
        this.activeTotal = 0;

        fire('page_view', {
            view_id: this.viewId,
            screen: 'detail',
            from: getPrevScreen(),
            search_id: this.searchId,
            penguin_name: this.penguinName,
            rank: this.rank || null,   // 検索結果での順位
            locale: this.$i18n.locale,
            aquarium: this.aquarium,
        });
        setCurrentScreen('detail');

        document.addEventListener('visibilitychange', this._onVis);
        window.addEventListener('beforeunload', this._flushLeave, { once: true });
    },
    created() {
        this.$returnScroll();
    },
    beforeDestroy() {
        this._flushLeave();
        document.removeEventListener('visibilitychange', this._onVis);
    },
    methods: {
        // バンドアイコンの枠線用
        isWhite(c) {
            if (!c) return false;
            const s = String(c).trim().toLowerCase();
            return s === 'white' || s === '#fff' || s === '#ffffff' || s === 'rgb(255,255,255)';
        },

        _onVis() {
            const now = performance.now();
            if (document.visibilityState === 'hidden') {
                this.activeTotal += now - this.activeStart;
            } else if (document.visibilityState === 'visible') {
                this.activeStart = now;
            }
        },
        _flushLeave() {
            if (!this.viewStart || this.viewLeft) return;
            this.viewLeft = true;
            const now = performance.now();
            const total = now - this.viewStart;
            if (document.visibilityState === 'visible') {
                this.activeTotal += now - this.activeStart;
            }
            fire('page_leave', {
                view_id: this.viewId,
                screen: 'detail',
                total_ms: Math.round(total),
                active_ms: Math.round(this.activeTotal),
            });
        },
        goBack() {
            fire('back_to_results', {
                search_id: this.searchId,
                penguin_name: this.penguinName
            });
            this.$router.push(`/${this.aquarium}/ranking`);
        },
        sendDB(path) {
            // まず確定ログ
            fire('confirm_correct', {
                search_id: this.searchId,
                penguin_name: this.penguinName,
                rank: this.rank || null
            });

            // drawingテーブルに送信(現状わからなかった(rank=0)だとデータが送信されないので直したい)
            let penguin_id = 'Unknown';
            if (this.rank > 0) {
                penguin_id = this.all_info[this.rank - 1]?.id || 'Unknown';
            }
            const data = {
                mail: this.$store.state.user.mail,  // ユーザーを識別するメールアドレス
                uid: this.$store.state.user.uid,
                aquarium: this.aquarium,
                penguin_name: penguin_id,
                image: this.$store.state.imgURL
            };
            this.$axios
                .post("https://nakagawa.nkmr.io/api/pensaku/post_drawing.php", data)
                .then((response) => {
                    console.log("status:", response.status);
                    // alert("送信しました");
                })
                .catch((error) => {
                    // alert("エラーが発生しました");
                    console.log("err:", error);
                });



            //サーバーに保存する作業
            var params = new URLSearchParams();
            params.append("name", this.$store.state.user.name);
            params.append("uid", this.$store.state.user.uid);
            params.append("aquarium", this.aquarium);
            params.append("penname", this.$store.state.penName);
            params.append("bandcolor", JSON.stringify(this.$store.state.bandColor));
            params.append("image", this.$store.state.imgURL);
            params.append("time", this.$store.state.drawTime);
            params.append("data", JSON.stringify(this.$store.state.data));
            params.append("ranking", JSON.stringify(this.all_info));
            params.append("part", JSON.stringify(this.$store.state.part));
            params.append("rank", this.rank);

            this.$axios
                .post("https://nakagawa.nkmr.io/api/pensaku/post_all.php", params)
                .then((response) => {
                    console.log("status:", response.status);
                    // alert("送信しました");
                })
                .catch((error) => {
                    // alert("エラーが発生しました");
                    console.log("err:", error);
                });

            this.dialog = false;
            this.$router.push(`/${this.aquarium}/${path}`);
        }
    }
}
</script>

<style>
.name-line {
    flex-basis: 100%;
    /* margin-top: 8px; */
}

.name-line h1 {
    display: block;
    flex-basis: 100%;
    width: 100%;
}

/* バンドの丸アイコン共通の見た目（サイズ/余白など） */
.band-icon {
    font-size: 18px;
    margin-left: 4px;
    vertical-align: middle;
}

/* 白のときだけ縁取り（Chrome/Safari/Edgeで効く） */
.band-white {
    -webkit-text-stroke: 1.0px #9d9d9d;
    /* 外周の線 */
    text-stroke: 1.0px #9d9d9d;
    /* 将来互換 */
}
</style>